// Requisitos gerais de sistema do jogo, por plataforma. Dados: packages/config/src/game-requirements.json.
// Só mostra as plataformas que têm ficheiro na versão atual (game-release.json).
import { GAME_REQUIREMENTS } from "@ecliptica/config/game-requirements";
import { GAME_RELEASE } from "@ecliptica/config/game-release";
import { useTranslation } from "@ecliptica/i18n";
import { Panel } from "./Section";

export function Requirements() {
  const { t } = useTranslation();
  const platforms = GAME_RELEASE.files.map((f) => f.platform);
  if (!platforms.length) return null;
  return (
    <Panel className="mx-auto mt-4.5 max-w-[1100px] p-5.5">
      <h3 className="mb-3 text-xl font-extrabold text-gold">{t("dl.req.title")}</h3>
      <div className="grid gap-6 md:grid-cols-2">
        {platforms.map((platform) => {
          return (
            <div key={platform} className="text-sm">
              <h4 className="mb-2 font-semibold">{t(`dl.req.platform.${platform}`)}</h4>
              <ul className="list-disc space-y-1 pl-5">
                <li>{t(`dl.req.os.${platform}`)}</li>
                <li>{t(`dl.req.gpu.${platform}`)}</li>
              </ul>
            </div>
          );
        })}
      </div>
      {GAME_REQUIREMENTS.network.online && <p className="mt-3 text-sm text-muted-foreground">{t("dl.req.online")}</p>}
    </Panel>
  );
}
